var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tk-image"},[_c('div',{staticClass:"tk-image-container"},[_vm._t("default")],2),_vm._v(" "),(!_vm.data.length)?_c('div',{staticClass:"tk-image-no-data"}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }